angular.module("app").directive("dragToOrder", function () {
    return {
        restrict: "A",
        scope: {
            originalValue: "=",
            dragToOrder: "=",
            index: "=",
            autoUpdate: "=",
            cb: "&"
        },
        link: function ($scope, element) {
            if ($scope.dragToOrder) {
                var callback = $scope.cb && $scope.cb();

                $(element).draggable({
                    helper: "clone",
                    drag: function (ev, ui) {
                        $(element).data('index', $scope.index)
                    }
                });
                $(element).droppable({
                    drop: function (ev, ui) {
                        ev.preventDefault();
                        var sourceIndex = +$(ui.draggable).data("index"),
                            sourceElement = $scope.originalValue[sourceIndex];
                        if (sourceIndex != $scope.index) {
                            $scope.originalValue.splice(sourceIndex, 1);
                            $scope.originalValue.splice($scope.index, 0, sourceElement);
                            $scope.$apply();
                            callback && callback({autoUpdate: $scope.autoUpdate});
                        }
                    }
                });
                $(element).on('dragover', function (e) { e.preventDefault();}, false);
                $(element).on('dragenter', function (e) { e.preventDefault();}, false);
            }

        }
    }
});